import { BlockTitle } from "@blocks/Blocks";
import AccordionV2 from "@components/Accordion/AccordionV2";
import Column from "@components/Grid/Column";

import SIAAccordionHeader from "./SIAAccordionHeader";

/**
 * Component to render SIA awards page
 */
const SIAAwardsPage = (): React.ReactElement => {
  return (
    <Column>
      <BlockTitle
        text="Awards"
        rootClassName="py-3 text-4xl md:text-6xl lg:text-8xl font-medium mb-8"
      />

      <AccordionV2
        testId="event-sia-individual-category-accordion"
        className="border border-gray-175 bg-gray-150"
        headerChildren={<SIAAccordionHeader title="Individual Category" />}
      >
        <div className=" px-6 py-4">
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Impact Leader of the Year</li>
            <li>Impact Leader Excellence Award</li>
          </ul>

          <p>
            <strong>Eligibility</strong>
          </p>

          <p>The individual should be based in Singapore.</p>

          <p>
            Individual who comes from entities with clear enterprise purpose,
            including business enterprises, social enterprises, GLCs, charities
            and NGOs, are welcomed to participate.
          </p>

          <p>
            The individual should meet the Terms and Conditions of the
            Nomination Declaration form.
          </p>

          <p className="pb-6">
            The following framework and criteria will be used for sustainability
            impact measurement:
          </p>

          <div className="lg:w-3/4">
            <p>
              <img src="https://static1.businesstimes.com.sg/s3fs-public/image/2023/01/26/individual-impact.jpeg?itok=eT3GhoD2" />
            </p>

            <p>
              <a
                className="text-[#007bad] hover:text-gray-750"
                href="/events-awards/sustainability-impact-awards/how-to-nominate#assessment"
              >
                <u>
                  <strong>Click here</strong>
                </u>
              </a>{" "}
              for the assessment criteria
            </p>
          </div>
        </div>
      </AccordionV2>

      <AccordionV2
        testId="event-sia-enterprise-category-accordion"
        className="border border-t-0 border-gray-175 bg-gray-150"
        headerChildren={<SIAAccordionHeader title="Enterprise Category" />}
      >
        <div className=" px-6 py-4">
          <p>SMEs</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Impact Enterprise of the Year</li>
            <li>Impact Enterprise Excellence Award</li>
          </ul>

          <p>Large Enterprise</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Impact Enterprise of the Year</li>
            <li>Impact Enterprise Excellence Award</li>
          </ul>

          <p>
            <strong>Definition</strong>
          </p>

          <p>
            Enterprises should be registered and based in Singapore. The Award
            categories are further subdivided into Small and Medium Enterprises
            (SMEs) and Large Enterprises.
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              According to Enterprise Singapore, SMEs refers to small and
              medium-sized enterprises, generally defined as an enterprise
              having an annual Group revenue of up to S$100 million, or maximum
              employment size of 200 employees.
            </li>
            <li>
              Large enterprises refer to an enterprise having an annual Group
              revenue larger than S$100 million, or employ more than 200
              employees.
            </li>
          </ul>

          <p>
            <strong>Eligibility</strong>
          </p>

          <p>The enterprise should be registered and based in Singapore.</p>

          <p>
            Entities with clear enterprise purpose, including business
            enterprises, social enterprises, GLCs, charities and NGOs, are
            welcomed to participate.
          </p>

          <p>
            The enterprise should meet the Terms and Conditions of the
            Nomination Declaration form.
          </p>

          <p className="pb-6">
            The following framework and criteria will be used for sustainability
            impact measurement:
          </p>

          <div className="lg:w-3/4">
            <p>
              <img src="https://static1.businesstimes.com.sg/s3fs-public/image/2024/02/23/enterprise_impact.jpg" />
            </p>

            <p>
              <a
                className="text-[#007bad] hover:text-gray-750"
                href="/events-awards/sustainability-impact-awards/how-to-nominate#assessment"
              >
                <u>
                  <strong>Click here</strong>
                </u>
              </a>{" "}
              for the assessment criteria
            </p>
          </div>
        </div>
      </AccordionV2>
    </Column>
  );
};
export default SIAAwardsPage;
